import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch, Radio, Collapse, AutoComplete
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import moment from 'moment'

import MultiAssocForm2 from "../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../components/permissions/PermissionAlert";
import ContactIcon from "../components/util-components/ContactIcon";
import {getConfig, getConfigs, getCountry, getDevise, getDeviseSymbol} from "../components/permissions/functions";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import OnlyAssoFieldContainer from "../components/custom-fields/OnlyAssoFieldContainer";
import ModalBasePaiement from "./ModalBasePaiement";
import {connect} from "react-redux";
import CampagneAddonForm from '../components/CampagneAddonForm';

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalAbonnement extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }


    initstate = {
        visible: false,
        loading: false,
        step: 0,
        defaultData: {},
        baseData:{}
    };

    state = this.initstate

    async show(contact = null) {
        console.log("ABONNEMENT  ",)

        this.modalBasePaiement.show(contact,(baseData)=>{
            this.setState({visible: true, baseData: {...baseData}})
        })
    }

    async showWithType(contact = null, type) {
        console.log("ABONNEMENT Type ", type)
        this.modalBasePaiement.showWithType(contact,type,(baseData)=>{
            this.setState({visible: true, baseData: {...baseData}})
        })
    }


    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        if (this.state.loading) {
            return false
        }

        this.setState({loading: true})

        var config = {
            ...this.state.baseData,
            name:data.name,
            montant: data.montant,
            cerfa: data.cerfa,
            cerfaYear: data.cerfaYear || false,
            commentaire: data.commentaire || null,
            extra: data.extra
        }

        if (config.type == "SERVICE") {
            config.service.nom = data.nom
            config.service.prenom = data.prenom
        }

        if (data.campagne) {
            config.campagne = data.campagne
        }

        config.nbMonth = data.nbMonth

        if (data.platform) {
            config.platform = data.platform
        }
        if (data.mandate) {
            config.mandate = data.mandate
        }
        if (data.datetime) {
            config.datetime = new Date(data.datetime.toDate())
        }

        console.log("config", config)

        var res = await ApiService.post("/abonnements/create/", config)
        console.log(res)

        this.setState({loading: false})

        if (res.success) {
            notification.success({
                message: t`Ajout réussi`
            })

            if (data.mandate) {
                this.close()
            } else {
                this.setState({step: 1, url: res.url})
            }
        } else {
            notification.error({
                message: t`Erreur lors de l'ajout`
            })
        }
    }


    render() {

        const baseData= this.state.baseData;

        const GCLConfig = getConfigs("GCL", "AUTH")

        return (

            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}} title={t`Créer un Abonnement`} open={this.state.visible}
                       destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.add"]}>


                        {this.state.step == 0 && (
                            <div style={{margin: "50px 50px"}}>
                                <Form
                                    initialValues={{
                                        nom: this.state.contact?.nom,
                                        prenom: this.state.contact?.prenom,
                                        nbMonth: 0,
                                        cerfa: baseData.typeData?.type == "SERVICE" ? baseData.typeData?.data?.cerfa : true,
                                        facturation: this.state.facturation ? this.state.facturation.id : null,
                                        montant: baseData.typeData?.type == "DETTE" ? baseData.typeData?.data?.reste : baseData.typeData?.type == "SERVICE" ? baseData.typeData?.data?.montant : null,
                                    }}
                                    onFinish={(data) => this.onFinish(data)}
                                >
                                    {baseData.typeData?.type == "SERVICE" && (
                                        <Fragment>
                                            <Divider><Trans>Bénéficiaire du Service</Trans></Divider>
                                            <Row justify="space-around" align="center">

                                                <Form.Item
                                                    label={t`Nom`}
                                                    name="nom"
                                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                >
                                                    <Input placeholder={t`Nom`}/>
                                                </Form.Item>

                                                <Form.Item
                                                    label={t`Prenom`}
                                                    name="prenom"
                                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                >
                                                    <Input placeholder={t`prenom`}/>
                                                </Form.Item>
                                            </Row>
                                            <Divider/>
                                        </Fragment>
                                    )}


                                    <Form.Item
                                        label={t`Nom de l'abonnement`}
                                        name="name"
                                    >
                                        <Input placeholder={t`Nom de l'abonnement`}/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t`Nombre de Mois (0 = infinie)`}
                                        name="nbMonth"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <InputNumber decimalSeparator={','} min={0}/>
                                    </Form.Item>

                                    <Form.Item noStyle shouldUpdate>
                                        {()=>{
                                            const devise=this.props.org.cerfasInfos.find(i=>i.id===(baseData?.assoc || "MAIN"))?.devise || getDevise()
                                            return(
                                                <Form.Item
                                                    label={t`Montant`}
                                                    name="montant"
                                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                >
                                                    <InputNumber
                                                        decimalSeparator={','} min={1}
                                                        step={0.5}
                                                        max={baseData.typeData?.type == "DETTE" ? baseData.typeData?.data?.reste : null}
                                                        addonAfter={getDeviseSymbol(devise)}
                                                    />
                                                </Form.Item>
                                            )
                                        }}
                                    </Form.Item>


                                    <Form.Item
                                        label={t`Cerfa`}
                                        name="cerfa"
                                    >
                                        <Switch
                                            defaultChecked={baseData.typeData?.type == "SERVICE" ? baseData.typeData?.data?.cerfa : true}/>
                                    </Form.Item>


                                    <Form.Item noStyle shouldUpdate>
                                        {(form) => {
                                            const bool = form.getFieldValue("cerfa")

                                            if (bool) {
                                                return (
                                                    <OnlyAssoFieldContainer assoc={baseData?.assoc} includeFormats={["FR"]}>
                                                        <Form.Item
                                                            preserve={false}
                                                            label={t`Reçu Cerfa Annuel`}
                                                            name={"cerfaYear"}
                                                        >
                                                            <Switch/>
                                                        </Form.Item>
                                                    </OnlyAssoFieldContainer>
                                                )
                                            }
                                        }}
                                    </Form.Item>


                                    <Form.Item
                                        label={t`Commentaire`}
                                        name="commentaire"
                                    >
                                        <Input.TextArea/>
                                    </Form.Item>


                                    {GCLConfig.length > 0 && (
                                        <Form.Item
                                            label={t`Plateforme de paiement`}
                                            name="platform"
                                        >
                                            <Radio.Group options={[{label: t`Carte`, value: 'CARD'}, {
                                                label: t`GoCardless`,
                                                value: 'PRELEVEMENT.GOCARDLESS'
                                            }]} optionType="button"/>
                                        </Form.Item>
                                    )}

                                    <Form.Item noStyle shouldUpdate>
                                        {(_form) => {
                                            if (_form.getFieldValue("platform") === "PRELEVEMENT.GOCARDLESS") {
                                                return (
                                                    <Fragment>
                                                        <Form.Item label={t`Identifiant du Mandat GoCardless`}
                                                                   name={"mandate"}>
                                                            <Input placeholder={t`MDXXXXXXXXXXXX`}/>
                                                        </Form.Item>

                                                        <Form.Item label={t`Date du premier prélèvement`}
                                                                   name={"datetime"}>
                                                            <DatePicker format={"DD/MM/YYYY"}/>
                                                        </Form.Item>
                                                    </Fragment>

                                                )
                                            }
                                            return null
                                        }}
                                    </Form.Item>


                                    {baseData.typeData?.type === "CAMPAGNE" && (
                                        <CampagneAddonForm name={"campagne"} campagneId={baseData?.typeData?.value}/>
                                    )}

                                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                        <Button type="primary" htmlType="submit" disabled={this.state.loading}
                                                loading={this.state.loading}>
                                            <Trans>Valider</Trans>
                                        </Button>
                                    </Form.Item>

                                </Form>
                            </div>
                        )}

                        {this.state.step === 1 && (
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 30
                            }}>
                                <a target="_blank" href={this.state.url}><Text
                                    copyable={{text: this.state.url}}><LinkOutlined/> {this.state.url}</Text></a>
                            </div>
                        )}
                    </PermissionAlert>
                </Modal>

                <ModalBasePaiement title={t`Créer un Abonnement`} getRef={(ref)=>this.modalBasePaiement=ref}/>
            </Fragment>


        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalAbonnement)
